import app from "js/legacy-app";

app.filter("insuranceType", [function () {
    return function (status) {
        switch (status) {
            case 'GENERAL_LIABILITY':
                return 'General Liability';
        }
    };
}]);